module.exports = __webpack_public_path__ + "static/img/lpa_header_logo.9d28f159.svg";